import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetAllActiveSystemBanners = () => {
  const get = useTypedApiClient({
    path: '/le-connect/system-banners/active',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/le-connect/system-banners/active'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
